import solver from 'solver-utilities';

const open = async function (event) {
	if (event) event.preventDefault();

	const delay = 10;
	const modal = document.querySelector('[data-el="size-chart-modal"]');
	const container = document.querySelector('[data-el="size-chart-container"]');
  const body = document.querySelector('body');

	if (!container || !modal) return;

	container.classList.add('size-chart__container--active');
  modal.classList.add('size-chart--active');

  await solver.each.asyncTimeout(delay);
  body.style.overflow = "hidden";

  modal.classList.add('animate__fadeIn');

	await solver.each.asyncTimeout(delay);
  container.classList.add('animate__slideInRight');
};

export const close = async function () {
	const delay = 10;
	const modal = document.querySelector('[data-el="size-chart-modal"]');
	const container = document.querySelector('[data-el="size-chart-container"]');
  const body = document.querySelector('body');

	container.classList.add('animate__slideOutRight');

  body.style.overflow = "unset";

	await solver.each.asyncTimeout(delay);

	modal.classList.add('animate__fadeOut');

	await solver.each.asyncTimeout(delay);

	modal.classList.remove('size-chart--active', 'animate__fadeOut', 'animate__fadeIn');
	container.classList.remove('animate__slideOutRight', 'animate__slideInRight', 'size-chart__container--active');
};


export const sizeChart = function () {
	window.Solver.openSizeChart = open;
	window.Solver.closeSizeChart = close;
};
